import axios from './axios.config';

export interface Inspection {
    id: number;
    trailerId: string;
    userId: number;
    status: 'in-progress' | 'completed' | 'cancelled' | 'failed';
    createdAt: string;
    updatedAt: string;
}

export interface InspectionHistory extends Inspection {
    trailerEvent: string;
}

export interface Checklist {
    id: number;
    inspectionId: number;
    name: string;
    status: 'pending' | 'in-progress' | 'passed' | 'failed' | 'acceptable';
    alertStatus: 'pending' | 'sent' | 'failed';
    imageUrls?: any[];
    faultPhotosUrls?: string[];
    photoUrls?: string[];
    remark?: string;
    analyzedAt?: string;
    createdAt: string;
    updatedAt: string;
}

export interface StartInspectionRequest {
    trailerId: string;
    userId: number;
    checklists: string[];
}

export interface UpdateChecklistStatusRequest {
    status: 'pending' | 'passed' | 'failed' | 'acceptable';
}

export const inspectionService = {
    startInspection: async (data: StartInspectionRequest): Promise<Inspection> => {
        try {
            const response = await axios.post<{ inspection: Inspection; }>('/inspection/start', data);
            return response.data.inspection;
        } catch (error) {
            throw error;
        }
    },

    getLastInProgressAndFailed: async (): Promise<Inspection | null> => {
        try {
            const response = await axios.get<Inspection>('/inspection/last-in-progress-and-failed');
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    getInspectionHistory: async (): Promise<InspectionHistory[]> => {
        try {
            const response = await axios.get<InspectionHistory[]>(`/inspection`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    cancelInspection: async (inspectionId: number): Promise<Inspection> => {
        try {
            const response = await axios.delete<Inspection>(`/inspection/${inspectionId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    getChecklistsByInspection: async (inspectionId: number): Promise<Checklist[]> => {
        try {
            const response = await axios.get<Checklist[]>(`/checklist/inspection/${inspectionId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

}; 